import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import { config } from "../config";

export async function makeApiCall(
  method,
  endpoint,
  payload = {},
  axiosOptions = {},
  signal = null
) {
  const url = config.controlPlaneAPI + endpoint;

  let authHeaders = {};
  try {
    const session = await fetchAuthSession();
    const token = session.tokens.idToken.toString();
    authHeaders = { Authorization: `Bearer ${token}` };
  } catch (e) {}

  const defaultOptions = {
    withCredentials: true,
    ...axiosOptions,
    headers: {
      ...authHeaders,
      ...(axiosOptions.headers || {}),
    },
    ...(signal && { signal }),
  };

  try {
    switch (method.toLowerCase()) {
      case "get":
        return await axios.get(url, defaultOptions);
      case "post":
        return await axios.post(url, payload, defaultOptions);
      case "put":
        return await axios.put(url, payload, defaultOptions);
      case "delete":
        return await axios.delete(url, defaultOptions);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  } catch (err) {
    if (axios.isCancel(err)) {
      throw err;
    }
    throw err;
  }
}
